import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export interface RoundedCheckProps extends SvgIconProps {
  readonly fillColor?: string
}

const RoundedCheck = forwardRef<SVGSVGElement, RoundedCheckProps>(
  function RoundedCheck({ fillColor = '#96C735', ...rest }, ref) {
    return (
      <SvgIcon ref={ref} {...rest}>
        <g fill="none" fillRule="evenodd" transform="translate(2.5 3)">
          <circle cx="9" cy="9" fill={fillColor} r="9" />
          <path d="M0 0h18v18H0z" />
          <path
            d="M7.5 11.32836L4.875 8.8209 4 9.65672 7.5 13 15 5.83582 14.125 5z"
            fill="#FFF"
          />
        </g>
      </SvgIcon>
    )
  },
)

export default RoundedCheck
